import PropTypes from 'prop-types';
import React from 'react';

import MediaCard from 'components/shared/media-card';

const MediaGridItem = ({ blok }) => (
  <div className="container py-7 lg:py-10">
    <MediaCard blok={blok} />
  </div>
);
export default MediaGridItem;

MediaGridItem.propTypes = {
  blok: PropTypes.object.isRequired,
};
